import { render } from "./WebHeader.vue?vue&type=template&id=5592e8b8"
import script from "./WebHeader.vue?vue&type=script&lang=js"
export * from "./WebHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__